<div
  class="menu-filtro panel-heading-container"
  *ngFor="let item of menu"
  (mouseenter)="item.selected = true"
  (mouseleave)="item.selected = false"
  (click)="item.selected = false"
>
  <div
    class="panel-heading-container"
    *ngIf="item.children.length; else elseBlockNotHasChildren"
  >
    <button
      data-toggle="collapse"
      type="button"
      class="panel-heading btn-panel {{ item.selected ? '' : 'collapsed' }}"
      (click)="onClick(item.description, item.children)"
    >
      {{ item.description }}
    </button>
    <div
      id="box{{ item.id }}"
      class="dropdown-box list-group list-group-flush panel-collapse collapse {{
        item.selected ? 'show' : ''
      }}"
    >
      <app-catalog-dropdown
        #submenu
        (onSelect)="onSelect($event)"
        *ngFor="let subItem of item.children"
        [item]="subItem"
        [selected]="subItem.selected"
        [parent]="item.description"
        (breadCrumb)="saveBc($event)"
      ></app-catalog-dropdown>
    </div>
  </div>

  <ng-template #elseBlockNotHasChildren>
    <a
      (click)="selectRoot(item.id, item.description)"
      style="cursor: pointer"
      class="panel-heading-no-subtitle"
      >{{ item.description }}</a
    >
  </ng-template>
</div>

<hr *ngIf="menu" />
